import { useCallback } from "react";

export type UseSmoothScrollOptions = {
  behavior?: ScrollBehavior;
  focus?: boolean;
  offsetTop?: number;
  offsetBottom?: number;
};

export const useSmoothScroll = () => {
  const scrollToId = useCallback(
    (id: string, options?: UseSmoothScrollOptions) => {
      const el = document.getElementById(id);
      if (!el) return;

      const offsetTop = options?.offsetTop ?? 40;
      const offsetBottom = options?.offsetBottom ?? 40;

      const rect = el.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      const isAbove = rect.top < offsetTop;
      const isBelow = rect.bottom > viewportHeight - offsetBottom;

      if (!isAbove && !isBelow) {
        if (options?.focus && el instanceof HTMLElement) {
          el.focus({ preventScroll: true });
        }
        return;
      }

      let scrollPosition = window.pageYOffset;

      if (isAbove) {
        scrollPosition += rect.top - offsetTop;
      } else if (isBelow) {
        scrollPosition += rect.bottom - viewportHeight + offsetBottom;
      }

      window.scrollTo({
        top: scrollPosition,
        behavior: options?.behavior ?? "smooth",
      });

      if (options?.focus && el instanceof HTMLElement) {
        el.focus({ preventScroll: true });
      }
    },
    [],
  );

  return { scrollToId };
};
